import { render, staticRenderFns } from "./otpBlock.vue?vue&type=template&id=1e5edaf8&scoped=true&"
import script from "./otpBlock.vue?vue&type=script&lang=js&"
export * from "./otpBlock.vue?vue&type=script&lang=js&"
import style0 from "./otpBlock.vue?vue&type=style&index=0&id=1e5edaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5edaf8",
  null
  
)

export default component.exports